import { CUSTOMER_DETAIL_VERIFY, CUSTOMER_DETAIL_VERIFY_SUCCESS, CUSTOMER_DETAIL_VERIFY_ERROR, CUSTOMER_DETAIL_VERIFY_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const CustomerDetailVerify = (state = initialState, action) => {
  switch (action.type) {
    case CUSTOMER_DETAIL_VERIFY:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CUSTOMER_DETAIL_VERIFY_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CUSTOMER_DETAIL_VERIFY_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CUSTOMER_DETAIL_VERIFY_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default CustomerDetailVerify;
